<script setup>
import { ref, watch } from "vue";
import { useResize } from "vui/composables/resize";

const content = ref(null);
const scroll = ref(false);
const scrollPos = ref(-1);

const size = useResize(content);

function next() {
	content.value.scrollBy({ left: content.value.clientWidth / 3, behavior: "smooth" });
}

function prev() {
	content.value.scrollBy({ left: -content.value.clientWidth / 3, behavior: "smooth" });
}

function scrolling(el) {
	if (el.scrollLeft < 20)
		scrollPos.value = -1;
	else if (el.scrollWidth - el.scrollLeft - el.clientWidth < 20)
		scrollPos.value = 1;
	else
		scrollPos.value = 0;
}

watch(size, () => {
	scroll.value = size.width < content.value.scrollWidth;
	scrolling(content.value);
});
</script>

<template>
	<div class="vui-scroll-x">
		<div ref="content" class="content" :class="{ scroll }" @scroll="scrolling($event.target)">
			<slot></slot>
		</div>
		<div class="prev" :class="{ show: scroll && scrollPos >= 0 }">
			<div class="btn-container">
				<button class="vui-btn-fa-circle" @click="prev()">
					<i class="fa-light fa-circle-chevron-left"></i>
				</button>
			</div>
			<div class="fade"></div>
		</div>
		<div class="next" :class="{ show: scroll && scrollPos <= 0 }">
			<div class="fade"></div>
			<div class="btn-container">
				<button class="vui-btn-fa-circle" @click="next()">
					<i class="fa-light fa-circle-chevron-right"></i>
				</button>
			</div>
		</div>
	</div>
</template>
